// extracted by mini-css-extract-plugin
export var content = "_nv-1";
export var noScroll = "_nv-3";
export var paper = "_nv-0";
export var scrollable = "_nv-2";